import * as Msal from "@azure/msal-browser";

// console.log(
//   process.env.VUE_APP_LOGIN_URL,
//   window.location.origin,
//   process.env.NODE_ENV
// );

export const msalConfig: Msal.Configuration = {
  auth: {
    clientId:
      process.env.VUE_APP_AZURE_AD_CLIENT_ID ||
      "7ee15a7a-5992-42b4-8e11-b88cb35288fe",
    authority:
      "https://login.microsoftonline.com/" +
      (process.env.VUE_APP_AZURE_AD_TENANT_ID ||
        "3485b963-82ba-4a6f-810f-b5cc226ff898"),
    redirectUri:
      process.env.VUE_APP_LOGIN_URL || window.location.origin + "/login",
    postLogoutRedirectUri:
      process.env.VUE_APP_LOGIN_URL || window.location.origin + "/login",
  },
  cache: {
    cacheLocation: "localStorage",
    // storeAuthStateInCookie: false,
  },
  // system: {
  //   tokenRenewalOffsetSeconds: 55 * 60,
  // },
};

export const loginRequest: Msal.RedirectRequest | Msal.PopupRequest = {
  scopes: [
    "openid",
    "profile",
    "User.Read",
    "People.Read",
    "Files.Read.All",
    "Files.ReadWrite.All",
  ],
  // forceRefresh: true,
};

export const clientScope: Msal.RedirectRequest | Msal.PopupRequest = {
  scopes: [
    `api://${
      process.env.VUE_APP_AZURE_AD_CLIENT_ID ||
      "7ee15a7a-5992-42b4-8e11-b88cb35288fe"
    }/.default`,
  ],
  // forceRefresh: true,
};

export const epdpApiScope: Msal.RedirectRequest | Msal.PopupRequest = {
  scopes: ["api://93ad3682-7502-462b-bb44-4bcbe799a31b/access_as_user"], // E-PDP API ClientId
};
